import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type IListBehaviorConfiguration, listBehaviorConfigurationsManager } from '@inpart-io/padme-iap';

import { store } from '../index';
import { actions } from './actions';
import { getters } from './getters';
import { type IListBehaviorConfigurationByTarget } from './types';

const LIST_BEHAVIOR_CONFIGURATION_MODULE = 'listBehaviorConfiguration';

const state: IListBehaviorConfigurationByTarget = {
    listBehaviorConfigurationByTarget: new Map()
};

const dataObjectModule = getDataObjectsModule<IListBehaviorConfiguration>(listBehaviorConfigurationsManager, 5);

const ListBehaviorConfigurationModuleInstance = merge<unknown>(dataObjectModule, { state, actions, getters });
store.registerModule(LIST_BEHAVIOR_CONFIGURATION_MODULE, ListBehaviorConfigurationModuleInstance);

export { LIST_BEHAVIOR_CONFIGURATION_MODULE };
